
export const getPlatform = () => {
	if (typeof window === 'undefined') return null;
	
	const userAgent = window.navigator.userAgent.toLowerCase();
	
	if (/android/.test(userAgent)) return 'ANDROID';
	if (/iphone|ipad|ipod/.test(userAgent)) return 'IOS';
	if (/mobile/.test(userAgent)) return 'MOBILE_WEB';
	
	return 'WEB';
};

export const WEB = 'WEB';
